import { handleActions } from '@gef-ui/utils/fsaActions';
import converge from "ramda/es/converge";
import identity from "ramda/es/identity";
import length from "ramda/es/length";
import map from "ramda/es/map";
import o from "ramda/es/o";
import repeat from "ramda/es/repeat";
import zipObj from "ramda/es/zipObj";
import { merge } from 'rxjs';
import { filter, scan, shareReplay } from 'rxjs/operators';
import { payloadKeepPristine } from '../../../utils/data';
import { actionNames, initFormState } from '../../transfer/control';
import { filterByActionType, skipWhenStateEqual } from '../../utils';
const formEditActions = [
    actionNames.SET_VALUE,
    actionNames.SET_VALUE_BY_DEEP_PATH,
    actionNames.APPEND_TO_LIST,
    actionNames.PREPEND_TO_LIST,
    actionNames.REMOVE_FROM_LIST,
    actionNames.CLEAR_LIST,
    actionNames.DEEP_MERGE_DATA,
    actionNames.REPLACE_DATA,
    actionNames.DEEP_MERGE_ROW,
    actionNames.REPLACE_ROW,
    actionNames.CLEAR_ROW
];
const handleFormEdit = (state, action)=>{
    if (state.pristine && !payloadKeepPristine(action)) {
        return {
            ...state,
            pristine: false
        };
    }
    return state;
};
const createFormEditHandlers = converge(zipObj, [
    identity,
    o(repeat(handleFormEdit), length)
]);
const scanReducer = (reducerHandler)=>handleActions({
        [actionNames.INIT_FORM_STATE]: (state, action)=>({
                ...state,
                pristine: state.pristine ?? true,
                disabled: action.payload?.disabled
            }),
        [actionNames.DISABLE_FORM]: (state, action)=>({
                ...state,
                pristine: true,
                disabled: action.payload
            }),
        [actionNames.RESET_FORM]: (state)=>({
                ...state,
                pristine: true
            }),
        ...createFormEditHandlers(formEditActions),
        ...reducerHandler
    }, {});
const defaultState = {};
export default (({ control$ }, { createInputs = [], reducerHandler = {} } = {}, initState = defaultState)=>{
    const extensionInputs$ = map((ext)=>ext({
            control$
        }), createInputs);
    const formState$ = merge(control$.pipe(filterByActionType(actionNames.INIT_FORM_STATE, actionNames.DISABLE_FORM, ...formEditActions)), control$.pipe(filterByActionType(control$, actionNames.RESET_FORM), filter(({ meta })=>meta.pristine)), ...extensionInputs$).pipe(scan(scanReducer(reducerHandler), {}), skipWhenStateEqual(), shareReplay(1));
    formState$.subscribe();
    // po prve se inicializuje pro skipWhenStateEqual. Urcite pujde vyresit lepe :)
    control$.next(initFormState({}));
    if (initState !== defaultState) {
        // form initialize itself in useForm, but if we already have data, then initialize it directly
        control$.next(initFormState(initState));
    }
    return formState$;
});
